const sanitizeName = text => text?.replace(/ +(?= )/g, '').trim();
const sanitizeDescription = text => text?.replace(/ +(?= )/g, '').trimStart();

const isStandardFeature = ({ is_custom: custom }) => !custom;
const isNonEmptyCustomFeature = ({ is_custom: custom, name }) => custom && name.trim();
const extractUuid = item => item.uuid;

const isNewCustomIntegration = integration => integration.uuid.startsWith('new-');
// If the integration is new, we use the name as the key and the backend will determine
// it's a duplicate and remove it or will generate a UUID.
const extractIntegrationKey = integration => (
    isNewCustomIntegration(integration) ? integration.name : integration.uuid
);

export function stateToAPIRequestTransformer(productState, productAdditions = {}) {
    // Destructure the product from the state and create a new object to avoid mutating the original state.
    const product = { ...productState }

    const filteredFeatures = {
        feature_uuids: product.features?.filter(isStandardFeature).map(extractUuid),
        custom_features: product.features?.filter(isNonEmptyCustomFeature),
    };
    delete product.features;

    const transformedIntegrationKeys = {
        integration_keys: product.integrations?.map(extractIntegrationKey),
    };
    delete product.integrations;
    delete product.standard_integrations;
    delete product.custom_integrations;

    return {
        ...product,
        name: sanitizeName(product.name),
        short_description: sanitizeDescription(product.short_description),
        long_description: sanitizeDescription(product.long_description),
        ...filteredFeatures,
        ...transformedIntegrationKeys,
        ...productAdditions,
    };
}
